/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type reconciliation_CandidateInvoiceSplitDTO = {
    childId?: string;
    childInternalId?: string;
    childName?: string;
    dueDate?: string;
    invoiceId: string;
    invoiceNumber: string;
    invoiceSplitId: string;
    originalCents?: number;
    outstandingCents?: number;
    periodLabel?: string;
    status?: reconciliation_CandidateInvoiceSplitDTO.status;
    /**
     * TotalAmountCents is the split's full invoiced amount (the child's share
     * of the invoice) BEFORE any payments. For a part-paid split it exceeds
     * OutstandingCents; the FE renders "CHF 437.75 of CHF 830.65" from the two.
     */
    totalAmountCents?: number;
};
export namespace reconciliation_CandidateInvoiceSplitDTO {
    export enum status {
        PENDING = 'pending',
        PARTIAL = 'partial',
        OVERDUE = 'overdue',
    }
}

